module.exports = __webpack_public_path__ + "img/small_fifa_banner.fe73e1b6.png";